import dayjs from 'dayjs';

/**
 * get friendly date
 * @param {String} date
 * @param {String} format
 * @returns {String}
 */
export const dateFriendly = (date, format = 'DD MMM YYYY') => {
	return dayjs(date).format(format);
};

/**
 * check valid date
 * @param {String} date
 * @returns {Boolean}
 */
export const isValidDate = (date) => {
	if (typeof (date) !== 'string') {
		return false;
	}
	return new Date(date).toString() !== 'Invalid Date';
};
